export default {
  namespaced  : true,

  state       : {
    publicListViewData   : {
      list      : [],
      
      page      : 1,
      lastPage  : null,
      total     : null,
      loaded    : false,
    },

    relatedListViewData   : {
      list      : [],
      
      page      : 1,
      lastPage  : null,
      total     : null,
      loaded    : false,
    }
  },

  mutations   : {
    removeParkInPublicList(state, payload){
      const newArray = [];
      
      for(let park of state.publicListViewData.list){
        if(park.id !== payload.parkId){
          newArray.push(park);
        }
      }

      state.publicListViewData.list = newArray;
    },

    removeParkInRelatedList(state, payload){
      const newArray = [];
      
      for(let park of state.relatedListViewData.list){
        if(park.id !== payload.parkId){
          newArray.push(park);
        }
      }

      state.relatedListViewData.list = newArray;
    },

    setRelatedListViewData(state, payload){
      if(typeof payload.list !== 'undefined'){
        if(typeof payload.behaviour === 'undefined'){
          payload.behaviour = 'refresh';
        }

        switch(payload.behaviour){
          case 'refresh':
            state.relatedListViewData.list     = payload.list;
          break;

          case 'push':
            for(let park of payload.list){
              let couldRegist = true;

              for(let registerdPark of state.relatedListViewData.list){
                if(registerdPark.id === park.id){
                  couldRegist = false;
                }
              }

              if(couldRegist){
                state.relatedListViewData.list.push(park);
              }
            }
          break;
        }
      }

      if(typeof payload.page !== 'undefined'){
        state.relatedListViewData.page     = payload.page;
      }

      if(typeof payload.lastPage !== 'undefined'){
        state.relatedListViewData.lastPage = payload.lastPage;
      }

      if(typeof payload.total !== 'undefined'){
        state.relatedListViewData.total    = payload.total;
      }

      if(typeof payload.loaded !== 'undefined'){
        state.relatedListViewData.loaded    = payload.loaded;
      }
    },

    setPublicListViewData(state, payload){
      if(typeof payload.list !== 'undefined'){
        if(typeof payload.behaviour === 'undefined'){
          payload.behaviour = 'refresh';
        }

        switch(payload.behaviour){
          case 'refresh':
            state.publicListViewData.list     = payload.list;
          break;

          case 'push':
            for(let park of payload.list){
              let couldRegist = true;

              for(let registerdPark of state.publicListViewData.list){
                if(registerdPark.id === park.id){
                  couldRegist = false;
                }
              }

              if(couldRegist){
                state.publicListViewData.list.push(park);
              }
            }
          break;
        }
      }

      if(typeof payload.page !== 'undefined'){
        state.publicListViewData.page     = payload.page;
      }

      if(typeof payload.lastPage !== 'undefined'){
        state.publicListViewData.lastPage = payload.lastPage;
      }

      if(typeof payload.total !== 'undefined'){
        state.publicListViewData.total    = payload.total;
      }

      if(typeof payload.loaded !== 'undefined'){
        state.publicListViewData.loaded    = payload.loaded;
      }
    },

    resetStore(state){
      state.publicListViewData.list     = [];
      state.publicListViewData.page     = 1;
      state.publicListViewData.lastPage = null;
      state.publicListViewData.total    = null;
      state.publicListViewData.loaded   = false;

      state.relatedListViewData.list     = [];
      state.relatedListViewData.page     = 1;
      state.relatedListViewData.lastPage = null;
      state.relatedListViewData.total    = null;
      state.relatedListViewData.loaded   = false;
    }
  },

  actions     : {
    updateListViewData(context, payload){
      switch(payload.listType){
        case 'public':
          context.commit('setPublicListViewData', payload);
        break;

        case 'related':
          context.commit('setRelatedListViewData', payload);
        break;
      }
    },

    updateRemoveParkInList(context, payload){
      switch(payload.listType){
        case 'public':
          context.commit('removeParkInPublicList', payload);
        break;

        case 'related':
          context.commit('removeParkInRelatedList', payload);
        break;
      }
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}